const SectionPembuka = () => {
  return (
    <>
      <div id="pembuka" className="overflow-x-hidden p-7 pt-10 text-center">
        <h2 className="mb-7 font-Amiri text-2xl" data-aos="fade-left" data-aos-duration="1000">
          بِسْمِ اللَّهِ الرَّحْمَنِ الرَّحِيْمِ
        </h2>
        <p className="mb-5 font-GreatVibes text-3xl" data-aos="fade-right" data-aos-duration="1000">
          Assalamu'alaikum Warahmatullahi Wabarakaatuh
        </p>
        <p className="text-justify" data-aos="fade-up" data-aos-duration="1000">
          Maha suci Allah SWT yang telah menciptakan makhluk-Nya berpasang-pasangan. Tanpa mengurangi rasa hormat, dengan ini kami bermaksud mengundang Bapak/Ibu/Sahabat untuk hadir pada acara pernikahan kami.
        </p>
      </div>
    </>
  );
};

export default SectionPembuka;
